globalThis.Alpine.directive("randomize", (r, { modifiers: l }) => {
  if (l.includes("children")) {
    const n = Array.from(r.children), c = l.includes("skip") ? Number(l.at(l.indexOf("skip") + 1)) : 0;
    for (let e = c; e < n.length; e++) {
      const t = Math.floor(Math.random() * (n.length - e)) + e;
      [n[e], n[t]] = [n[t], n[e]];
    }
    r.replaceChildren(...n);
  }
});
